var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu',{staticClass:"navbar",attrs:{"mode":"horizontal"}},[_c('hamburger',{staticClass:"hamburger-container",attrs:{"toggleClick":_vm.toggleSideBar,"isActive":_vm.sidebar.opened}}),_c('tags-view',{staticStyle:{"margin-left":"30px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }